import React, { Component } from "react";
import { DatePicker, Button, message } from "antd";
import Select from "react-select";
import moment from "moment";
import { request } from "../../util/APIUtils";
import { API_BASE_URL } from "../../constants";
import Table from "../../components/Table/Table";
import { showAxiosError } from "../../util/Helpers";

class DutyRosterForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filterDate: props.selectedDate ? moment(props.selectedDate) : moment(),
            selectedRegion: null,
            regions: [],
            pharmacies: [],
            selectedPharmacies: [],
            loading: false,
            isEditMode: !props.addMode,
            page: 0,
            size: 10,
            total: 0,
            submitting: false
        };
    }

    componentDidMount() {
        this.loadRegions();

        if (this.state.isEditMode) {
            this.loadExistingList();
        } else {
            this.loadPharmacies(null, null, 0, this.state.size);
        }
    }



    loadRegions = async () => {
        try {
            const res = await request({
                url: API_BASE_URL + "/duty-rosters/regions",
                method: "GET"
            });

            const data = Array.isArray(res.data) ? res.data : [];
            if (!data.length) {
                message.warning("Sunucudan bölge listesi alınamadı.");
            }

            const regions = [
                { value: null, label: "TÜM BÖLGELER" },
                ...data.map(r => ({
                    value: r.id,
                    label: r.regionName
                }))
            ];


            this.setState({ regions });
            return regions;
        } catch (e) {
            message.error("Bölgeler yüklenemedi.");
            return [];
        }
    };

    loadExistingList = async () => {
        const roster = this.props.selectedRoster || {};
        const dutyDate = roster.dutyDate;
        const region = roster.region;
        const regionId = roster.regionId;
        const regionName = roster.regionName;

        const resolvedRegionId =
            region && region.id ? region.id :
                regionId ? regionId : null;

        const resolvedRegionName =
            region && region.regionName ? region.regionName :
                regionName ? regionName : "";

        if (!resolvedRegionId) {
            message.error("Düzenlenecek nöbet listesinde bölge bilgisi eksik.");
            return;
        }

        const selectedRegion = { value: resolvedRegionId, label: resolvedRegionName };

        this.setState({
            loading: true,
            selectedRegion,
            filterDate: moment(dutyDate)
        });

        try {
            const res = await request({
                url:
                    API_BASE_URL +
                    "/duty-rosters/by-date-region?date=" +
                    dutyDate +
                    "&regionName=" +
                    encodeURIComponent(resolvedRegionName),
                method: "GET"
            });

            const duties = Array.isArray(res.data) ? res.data : [];

            const selectedPharmacies = duties.map(d => {
                const e = d.eczane || {};
                const r = e.region || {};

                return {
                    id: e.id ? e.id : null,
                    name: e.name ? e.name : "",
                    regionId: r.id ? r.id : null,
                    regionName: r.regionName ? r.regionName : ""
                };
            });

            this.setState({ selectedPharmacies });

            await this.loadPharmacies(null, null, 0, this.state.size);
        } catch (e) {
            this.setState({ loading: false });
            message.error("Nöbet listesi yüklenemedi.");
        }
    };

    handleUpdateList = async () => {
        const { selectedPharmacies, selectedRegion, filterDate } = this.state;

        if (!selectedPharmacies || selectedPharmacies.length === 0) {
            message.warning("Liste boş olamaz.");
            return;
        }

        const payload = selectedPharmacies.map(p => ({
            eczaneId: p.id,
            dutyDate: filterDate.format("YYYY-MM-DD") + "T08:30:00",
            regionId: selectedRegion.value
        }));

        this.setState({ submitting: true });
        const hide = message.loading("Nöbet listesi güncelleniyor, lütfen bekleyin...", 0);

        try {
            await request({
                url: API_BASE_URL + "/duty-rosters/update-assignments",
                method: "PUT",
                data: payload
            });

            hide();
            message.success("Nöbet listesi başarıyla güncellendi.");
            this.props.cancelProcess();

        } catch (e) {
            hide();
            showAxiosError(e);
        } finally {
            this.setState({ submitting: false });
        }
    };


    loadPharmacies = async (accessor, direction, page, size) => {
        const { selectedRegion, searchName } = this.state;

        const currentPage = typeof page === "number" ? page : this.state.page;
        const currentSize = typeof size === "number" ? size : this.state.size;

        const nameParam = searchName ? `&name=${encodeURIComponent(searchName)}` : "";
        const regionParam =
            selectedRegion && selectedRegion.value
                ? `&regionId=${selectedRegion.value}`
                : "";

        this.setState({ loading: true });

        const sortStr = accessor
            ? `&sort=${accessor},${direction || "asc"}`
            : "&sort=id,asc";

        const url =
            API_BASE_URL +
            `/pharmacies/allPharmacy?page=${currentPage}&size=${currentSize}${sortStr}${regionParam}${nameParam}`;

        try {
            const res = await request({ url, method: "GET" });
            const data = res.data || {};

            this.setState({
                pharmacies: data.content || [],
                total: data.totalElements || 0,
                page: data.number !== undefined ? data.number : currentPage,
                size: data.size !== undefined ? data.size : currentSize,
                loading: false
            });
        } catch (e) {
            this.setState({ loading: false });
            message.error("Eczaneler yüklenemedi.");
        }
    };


    handleDateChange = date => this.setState({ filterDate: date });

    handleRegionChange = selectedRegion => {
        this.setState(
            { selectedRegion, page: 0 },
            () => this.loadPharmacies(null, null, 0, this.state.size)
        );
    };


    handleAddPharmacy = (pharmacy) => {
        const { selectedPharmacies } = this.state;
        const regionId =
            pharmacy.regionId ? pharmacy.regionId :
                (pharmacy.region ? pharmacy.region.id : null);

        const exists = selectedPharmacies.some(p => p.id === pharmacy.id);
        if (exists) {
            message.info("Bu eczane zaten listede.");
            return;
        }

        this.setState({
            selectedPharmacies: [
                ...selectedPharmacies,
                {
                    ...pharmacy,
                    regionId: regionId,
                    regionName:
                        pharmacy.regionName ||
                        (pharmacy.region && pharmacy.region.regionName) ||
                        ""
                }
            ]
        });
    };


    handleRemovePharmacy = id => {
        this.setState(prev => ({
            selectedPharmacies: prev.selectedPharmacies.filter(p => p.id !== id)
        }));
    };

    handleCreateList = async () => {
        const { selectedPharmacies, selectedRegion, filterDate } = this.state;

        if (!selectedPharmacies || selectedPharmacies.length === 0) {
            message.warning("Listeye eczane eklemediniz.");
            return;
        }

        const payload = {
            dutyDate: filterDate.format("YYYY-MM-DD") + "T08:30:00",
            pharmacies: selectedPharmacies.map(p => ({
                eczaneId: p.id,
                regionId: p.regionId ? p.regionId : (p.region ? p.region.id : null)
            }))
        };

        this.setState({ submitting: true });
        const hide = message.loading("Nöbet listesi oluşturuluyor, lütfen bekleyin...", 0);

        try {
            await request({
                url: API_BASE_URL + "/duty-rosters/assign-multi-region",
                method: "POST",
                data: payload
            });
            hide();
            message.success("Nöbet listesi başarıyla oluşturuldu.");
            this.props.cancelProcess();
        } catch (e) {
            hide();
            if (e.response && e.response.data) {
                message.warning(
                    e.response.data.message || "İşlem sırasında hata oluştu."
                );
            } else {
                message.error("Liste oluşturulamadı.");
            }
        } finally {
            this.setState({ submitting: false });
        }


    };

    render() {
        const {
            filterDate,
            regions,
            selectedRegion,
            pharmacies,
            selectedPharmacies,
            loading,
            isEditMode
        } = this.state;

        const columns = [
            {
                Header: "Eczane Adı",
                accessor: "name",
                Cell: (item) => {
                    const regionName =
                        item.regionName ||
                        (item.region && item.region.regionName) ||
                        "";

                    return (
                        <span>
                            {item.name} {regionName ? `(${regionName})` : ""}
                        </span>
                    );
                }

            },
            {
                Header: "İşlem",
                Cell: (col, pharmacy) => {
                    const exists = selectedPharmacies.some(p => p.id === pharmacy.id);
                    if (exists) {
                        return <span style={{ color: "gray" }}>Listede</span>;
                    }
                    return (
                        <Button
                            size="small"
                            type="primary"
                            onClick={() => this.handleAddPharmacy(pharmacy)}
                            style={{ background: "#4CAF50", borderColor: "#4CAF50" }}
                        >
                            Ekle
                        </Button>
                    );
                }
            }
        ];

        return (
            <div className="card-body container mt-3">
                <h4>{isEditMode ? "Nöbet Listesi Düzenle" : "Yeni Nöbet Listesi Oluştur"}</h4>

                <div className="row mt-3 mb-4">
                    <div className="col-3">
                        <label>Tarih</label>
                        <DatePicker
                            value={filterDate}
                            format="YYYY-MM-DD"
                            onChange={this.handleDateChange}
                            disabled={isEditMode}
                        />
                    </div>

                    <div className="col-4">
                        <label>Bölge</label>
                        <Select
                            options={regions}
                            value={selectedRegion}
                            onChange={this.handleRegionChange}
                            placeholder="Bölge seçiniz"
                            isDisabled={isEditMode}
                            isSearchable={true}
                        />
                    </div>
                    <div className="col-4">
                        <label>Eczane Ara</label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Eczane adı ile ara..."
                            onChange={(e) => {
                                const val = e.target.value;

                                const normalized = val
                                    .toLocaleUpperCase("tr")
                                    .replace(/[âîû]/g, (c) => {
                                        const map = { "â": "a", "î": "i", "û": "u" };
                                        return map[c];
                                    });

                                this.setState({ searchName: normalized }, () =>
                                    this.loadPharmacies(null, null, 0, this.state.size)
                                );
                            }}
                        />
                    </div>
                </div>

                <div className="mb-4">
                    <h5>Seçilen Eczaneler ({selectedPharmacies.length})</h5>

                    {selectedPharmacies.length === 0 ? (
                        <p>Henüz eczane eklenmedi.</p>
                    ) : (
                        <ul style={{ listStyle: "none", padding: 0 }}>
                            {selectedPharmacies.map(p => (
                                <li
                                    key={p.id}
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        backgroundColor: "#e6f7ff",
                                        border: "1px solid #91d5ff",
                                        borderRadius: 4,
                                        padding: "6px 10px",
                                        marginBottom: 6
                                    }}
                                >
                                    <span style={{ flex: 1, fontWeight: 500 }}>
                                        {p.name} {(p.regionName || (p.region && p.region.regionName)) ?
                                            `(${p.regionName || p.region.regionName})` : ""}
                                    </span>
                                    <Button
                                        size="small"
                                        type="danger"
                                        onClick={() => this.handleRemovePharmacy(p.id)}
                                    >
                                        Çıkar
                                    </Button>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>

                <Table
                    loading={loading}
                    content={pharmacies}
                    columns={columns}
                    page={this.state.page}
                    size={this.state.size}
                    total={this.state.total}
                    fetchData={this.loadPharmacies}
                    paginationEnabled={true}
                />

                {!isEditMode ? (
                    <Button
                        type="primary"
                        onClick={this.handleCreateList}
                        loading={this.state.submitting}
                        disabled={selectedPharmacies.length === 0 || this.state.submitting}
                        style={{
                            background: "#0a66b7",
                            borderColor: "#0a66b7",
                            color: "white",
                            marginTop: 15
                        }}
                    >
                        Listeyi Oluştur
                    </Button>
                ) : (
                    <Button
                        type="primary"
                        onClick={this.handleUpdateList}
                        loading={this.state.submitting}
                        disabled={selectedPharmacies.length === 0 || this.state.submitting}
                        style={{
                            background: "#4CAF50",
                            borderColor: "#4CAF50",
                            color: "white",
                            marginTop: 15
                        }}
                    >
                        Kaydet
                    </Button>
                )}
            </div>
        );
    }
}

export default DutyRosterForm;



// WEBPACK FOOTER //
// ./src/page/dutyRoster/DutyRosterForm.js